/** @jsxImportSource react */
import React, { useCallback } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '@/firebase';
import { usePlatformStatus } from '@/contexts/PlatformStatusContext';
import { clearSessionData } from '@/utils/tokenValidation';
import { clearImpersonation } from '@/utils/authToken';
import { MaintenanceView } from './MaintenanceView';
import './MaintenanceView.css';

async function clearLocalSession(): Promise<void> {
  try {
    await signOut(auth);
  } catch {
    // JWT local se limpia igual
  }
  clearImpersonation(false);
  clearSessionData();
}

export function PlatformMaintenanceScreen() {
  const { refresh, refreshing } = usePlatformStatus();

  const handleSignOut = useCallback(async () => {
    await clearLocalSession();
    window.location.href = '/';
  }, []);

  const handleAdminAccess = useCallback(async () => {
    await clearLocalSession();
    window.location.href = '/?maintenance_admin=1';
  }, []);

  return React.createElement(
    'div',
    {
      className: 'maintenance-view maintenance-view--session-gate',
      style: {
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        boxSizing: 'border-box',
      },
    },
    React.createElement(MaintenanceView, {
      onRetry: () => void refresh(),
      onAdminAccess: () => void handleAdminAccess(),
      onSignOut: () => void handleSignOut(),
      isRetrying: refreshing,
    }),
  );
}
